// extracted by mini-css-extract-plugin
export default {"item":"webpack-concepts-Extraction-Extract-ExtractForm-module__item"};